import ItemRouteCreator from "./ItemRouteCreator.js";
export default (molten, cxt) => {
  const {
    relationship
  } = cxt;
  const routeId = `route.${relationship.path}.ItemScreen`;
  molten.addPlugin('Route', ItemRouteCreator({
    id: routeId,
    relationship
  }));
};